import React from 'react';

import BoxConteudo from '../../../../../components/BoxConteudo';
import CustomCol from '../../../../../components/CustomCol';
import CustomRow from '../../../../../components/CustomRow';
import CustomSelect from '../../../../../components/CustomSelects/CustomSelect';
import Input from '../../../../../components/InputNew';
import { SelectOption } from '../../../../../modules/types/types';

interface DadosAdministrativosProps {
  formProaq: any;
  proaqStatusOptions: SelectOption[];

  componenteAFOptions: SelectOption[];
  tipoModalidadeOptions: SelectOption[];
  subtipoModalidadeData: SelectOption[];
  subtipoModalidadeSrpData: SelectOption[];
  getUsuariosResponsaveis: string;
  itensData: any[];
  formatValorDinheiro: (valor: string) => string;
  handleChange: (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => void;
}

const DadosAdministrativos: React.FC<DadosAdministrativosProps> = ({
  formProaq,
  proaqStatusOptions,
  componenteAFOptions,
  tipoModalidadeOptions,
  subtipoModalidadeData,
  subtipoModalidadeSrpData,
  getUsuariosResponsaveis,
  itensData,
  formatValorDinheiro,
  handleChange,
}) => {
  return (
    <BoxConteudo boxTitulo="Dados Administrativos">
      <CustomRow>
        <CustomCol width="200px">
          <CustomSelect
            name="status"
            value={formProaq.status}
            options={proaqStatusOptions}
            onChange={handleChange}
            title="Status"
            required
          />
        </CustomCol>
        <CustomCol width="170px">
          <Input
            id="componenteAF"
            name="componenteAF"
            // value={
            //   componenteAFOptions[formProaq.componenteAF]
            //     ? componenteAFOptions[formProaq.componenteAF].label
            //     : ''
            // }
            value={
              componenteAFOptions.find(
                (componente) => componente.value == formProaq.componenteAF,
              )?.label || 'Não informado'
            }
            label="Componente AF"
            readonly
          />
        </CustomCol>
        <CustomCol width="220px">
          <Input
            id="modalidadeAquisicao"
            name="modalidadeAquisicao"
            value={
              tipoModalidadeOptions.find(
                (modalidadeOption) =>
                  modalidadeOption.value === Number(formProaq.modalidade),
              )?.label ?? ''
            }
            label="Mod. Aquisição"
            readonly
          />
        </CustomCol>
        <CustomCol width="220px">
          <Input
            id="subtipoModalidade"
            name="subtipoModalidade"
            value={
              Number(formProaq.modalidade) == 134
                ? (subtipoModalidadeData.find(
                    (submodalidade) =>
                      submodalidade.value === Number(formProaq.submodalidade),
                  )?.label ?? '')
                : (subtipoModalidadeSrpData.find(
                    (submodalidade) =>
                      submodalidade.value === Number(formProaq.submodalidade),
                  )?.label ?? '')
            }
            label="Subtipo Modalidade"
            readonly
          />
        </CustomCol>

        <CustomCol width="240px">
          <Input
            id="numeroSeiProaq"
            name="numeroSeiProaq"
            value={formProaq.numeroSeiProaq}
            label="Nº Processo Sei"
            mascara="99999.999999/9999-99"
            onChange={handleChange}
            required
          />
        </CustomCol>
        <CustomCol width="150px">
          <Input
            id="numeroEtp"
            name="numeroEtp"
            value={formProaq.numeroEtp}
            label="Nº ETP"
            onChange={handleChange}
            placeholder="N/I"
          />
        </CustomCol>
        <CustomCol>
          <Input
            id="responsavel"
            name="responsavel"
            value={getUsuariosResponsaveis || 'Não informado'}
            label="Responsável(is) Técnico(s)"
            readonly
          />
        </CustomCol>
      </CustomRow>
      <CustomRow>
        <CustomCol>
          {formProaq.denominacaoGenericaId != 0 &&
          formProaq.denominacaoGenericaId != null ? (
            <Input
              id="denominacaoGenerica"
              name="denominacaoGenerica"
              value={formProaq.denominacaoGenerica}
              label="Denominação Genérica"
              readonly
            />
          ) : (
            <Input
              id="kitDeProdutos"
              name="kitDeProdutos"
              value={formProaq.kitDeProdutos}
              label="Kit de Produto DAF"
              readonly
            />
          )}
        </CustomCol>
        <CustomCol width="100px">
          <Input
            id="totalItens"
            name="totalItens"
            value={itensData.length}
            label="Nº Itens"
            textAlign="right"
            readonly
          />
        </CustomCol>
        <CustomCol width="15%">
          <Input
            id="valorTotal"
            name="valorTotal"
            value={
              'R$ ' +
              formatValorDinheiro(
                itensData
                  .reduce(
                    (somador: number, itemAtual: any) =>
                      somador + parseFloat(itemAtual.valorTotalEstimado || '0'),
                    0,
                  )
                  .toFixed(2),
              )
            }
            label="Valor Total"
            textAlign="right"
            readonly
          />
        </CustomCol>
      </CustomRow>
    </BoxConteudo>
  );
};

export default DadosAdministrativos;
